import React from 'react';
import { connect } from 'react-redux';
import {langCheck,imLogin,getWindow} from "Pub/js/utils";
import platform from "Pub/js/platform";
import pubSubActions from "Pub/js/pubSubActions";
const { PubSub , base } = platform;
const { NCTooltip } = base;
import './IM.less';
class IM extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasImInit: false,
            loading: false,
            appOption: {},
            intelligentResponse: null,
            xiaoyouSendTime: '',
            // hasBindEvent: false,
            hasSendOpenMsg: false,
            unreadTotalNum: 0, //未读消息数量
            imVisible: false,
        }
        //本文件sonar扫描箭头函数不能解析，为了让sonar扫描通过，只能先这么写
        this.appendSdk = this.appendSdk.bind(this);
        this.appendLoginIframe = this.appendLoginIframe.bind(this);
        this.toolInit = this.toolInit.bind(this);
        // this.xiaoyouOpenApp = this.xiaoyouOpenApp.bind(this);
        // this.login = this.login.bind(this);
        this.handleImXiaoxi = this.handleImXiaoxi.bind(this);
    }

    handleImMessage = (e) => {
        let msgData;
        try {
            msgData = JSON.parse(e.data);
            // console.log('handleImMessage', msgData);
            const { event, data } = msgData;
            if (event) {
                if (event === 'imHide') {
                    if (data) {
                        this.setState({
                            imVisible: false
                        })
                    }
                }
                if (event === 'onUnReadedNumChanged') {
                    const { unreadTotalNum } = data;
                    this.setState({ unreadTotalNum });
                }
            }
        } catch(err) {}
    }

    // 动态添加IM的组件js
    appendSdk(appSrc,url,nccContext) {
        // if(document.getElementById('imAppSrc')) {
        //     this.appendLoginIframe(url,nccContext);
        //     return;
        // }
        // let myScript = document.createElement("script");
        // myScript.type = "text/javascript";
        // myScript.id = "imAppSrc";
        // // myScript.src = "https://mz-daily.yyuap.com/static/workbench_im/app.js";//daily环境
        // // myScript.src = "https://mz.yonyoucloud.com/static/workbench_im/app.js";//正式环境
        // myScript.src = appSrc;
        // document.getElementsByTagName("head")[0].appendChild(myScript);
        // myScript.onload = () => {
        //     this.appendLoginIframe(url,nccContext);
        // }

        // im初始化必须在单点之后
        this.appendLoginIframe(url, () => {
            const imIframeExisted = this.imContainerRef.querySelector('iframe');
            if (imIframeExisted) {
                return;
            }
            
            const imIframe = document.createElement('iframe');
            // const IMSRC = 'https://bip-daily.yonyoucloud.com/iuap-im-core/ucf-wh/index.html';
            imIframe.src = appSrc;
            this.imContainerRef.appendChild(imIframe);
            imIframe.onload = () => {
                setTimeout(() => { // 延迟执行，确保单点登录已完毕
                    this.toolInit(nccContext);
                }, 1000);
            }
        });
    }
    // 加载登录的iframe
    appendLoginIframe(url, callback) {
        if(document.getElementById('imxyframe')) {
            document.getElementsByTagName("head")[0].removeChild(document.getElementById('imxyFrame'));
        }
        // 如果iframe的src为null时候 不创建iframe.
        if(!url) {
            return;
        }
        let loginIframeScr = document.createElement('iframe');      //创建iframe 
        loginIframeScr.src = url; 
        loginIframeScr.style.display = 'none';  
        loginIframeScr.id = 'imxyFrame'; 
        document.getElementsByTagName("head")[0].appendChild(loginIframeScr);   //将iframe标签嵌入到head中 
        
        
        if (loginIframeScr.attachEvent){
            //如果为ie浏览器则页面加载完成后立即执行            
            loginIframeScr.attachEvent("onload", () => {      
                callback();
            });    
        } else {    
            loginIframeScr.onload = () => {
                callback();
            }; 
            
        }
    }
    componentDidMount() {
        window.addEventListener('message', this.handleImMessage);
        if(this.props.needBind) {
            return;
        }
        // this.appendSdk();
        this.login();
        this.rerender();
    }
    componentDidUpdate(prevProps,prevState) {
        // 优化绑定后im的初始化。之前多用了个更新im的属性。
        if((prevProps.needBind !== this.props.needBind) && !this.props.needBind) {
            // this.appendSdk();
            this.login();
            this.rerender();
        }
        //打开节点 为解决初始化加载需要触发两次才能打开节点所以写到这里
        if(this.state.hasSendOpenMsg) {
            window.openNew(this.state.appOption,true,JSON.stringify(this.state.intelligentResponse));
            this.setState({
                hasSendOpenMsg: false
            })
        }
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.handleImMessage)
    }
    
    /**
     * 初始化im对话框
     */
    toolInit(nccContext) {
        if(this.state.hasImInit) {
            return;
        }

        const eventbus = (function() {
            // let events = {};
        
            // const isWhateType = (obj, type) => {
            //     return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === type;
            // }
            return {
                // list: events,
                // on: function(event, callback) {
                //     if (isWhateType(event, 'string')) {
                //         if (isWhateType(callback, 'function')) {
                //             events[event] = events[event] || [];
                //             let index = events[event].indexOf(callback);
                //             if (index == -1) {
                //                 events[event].push(callback);
                //             }
                //         }
                //     }
                // },
                // off: function(event, callback) {
                //     if (isWhateType(event, 'string')) {
                //         if (isWhateType(callback, 'function')) {
                //             events[event] = events[event] || [];
                //             let index = events[event].indexOf(callback);
                //             if (index != -1) {
                //                 events[event].splice(index, -1);
                //             }
                //         }
        
                //         if (isWhateType(callback, 'undefined')) {
                //             events[event] = null;
                //         }
                //     }
        
                //     if (isWhateType(event, 'undefined')) {
                //         events = null;
                //         events = {};
                //     }
                // },
                dispatch: (event, params) => {
                    // platform在用(switchChatTo)
                    if (event) {
                        // const event = args[0];
                        // if (isWhateType(event, 'string') && events[event]) {
                            // const params = Array.prototype.splice.call(args, 1, args.length);
                            this.setState({
                                imVisible: true
                            }, () => {
                                this.getImWindow().postMessage({[event]: params}, this.imUrl);
                            })
                            // for (let x in events[event]) {
                            //     if (events[event].hasOwnProperty(x)) {
                            //         try {
                            //             events[event][x].apply(null, params);
                            //         } catch (error) {
                            //             console.log('EventHandleError.', error);
                            //         }
                            //     }
                            // }
                        // }
                    }
                }
            }
        }).call(this);

        let context = {
            appcode: "nccloud",
            // locale: "zh_CN",
            // tenantid: nccContext.tenantId,
            // token: nccContext.token,
            // username: "",
            // "theme": "", 
            // "username": "", 
            // "timezone": "" ,
            // userid: "c4b63717-e651-47c4-9e7b-e4e7d88293ec",
            // "token": "c4b63717-e651-47c4-9e7b-e4e7d88293ec",
            // token: "e63cdd27-cc2d-411e-8d7a-2eb18143b251", //小友daily环境
            // token: "96b00f22-7267-45da-8cd7-4a8d8b70f5c5", //小友正式环境
            // token: nccContext.token,
            // profile: nccContext.profile // online 正式环境、 pre 预发环境、 daily 日常环境
            ...nccContext
        }
        // const config = {
        //     el: 'messageContainer'
        // }
        
        // InitEsnIM(eventbus, context, config);
        this.getImWindow().postMessage({
            type: 'InitEsnIM',
            context,
        }, this.imUrl);

        // this.xiaoyouOpenApp(eventbus);
        // this.ImTool = eventbus;
        getWindow().ImTool =  eventbus;
        setTimeout(() => { // 延迟，确保im初始化完毕
            this.setState({
                hasImInit: true
            })
        }, 2000)
    }

    getImWindow = () => this.imContainerRef.querySelector('iframe').contentWindow;
    
    /**
     * 通过小友打开单据 
     */
    // xiaoyouOpenApp(tool) {
        // let hidden;
        // if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
        //     hidden = "hidden";
        // } else if (typeof document.msHidden !== "undefined") {
        //     hidden = "msHidden";
        // } else if (typeof document.webkitHidden !== "undefined") {
        //     hidden = "webkitHidden";
        // }
        // if (event === 'onReceivedMessage') {
        //     const msg = data;
        //     if (msg.data.extend) {
        //         let stringResponse = JSON.parse(msg.data.extend).intelligentResponse;
        //         if (stringResponse) {
        //             let intelligentResponse = JSON.parse(stringResponse);
        //             let { entity, word, pointcode, is_cloud_app, action } = intelligentResponse;
        //             // 判断是否为打开应用节点
        //             if (entity === 'openPoint' || entity === 'form' || action === 'openPoint') {
        //                 let appOption = {
        //                     name: word,
        //                     appcode: pointcode,
        //                     is_cloud_app: is_cloud_app,
        //                 };
                    
        //                 if(!document[hidden]) {  
        //                     this.setState({
        //                         appOption: { ...appOption },
        //                         intelligentResponse: { ...intelligentResponse },
        //                         xiaoyouSendTime: new Date().getTime(),
        //                         hasSendOpenMsg: true,
        //                     });
        //                 }

        //             } else {
        //                 this.setState({ hasSendOpenMsg: false });
        //             }
        //         }
        //     }
        // }
    // }



    /**
     * 登录
     */
    login = async ()=> {
        const data = await imLogin();
        data && appendIMSdk.call(this, data);
        
        function appendIMSdk(data) {
            const { login_url, im_url, xiaoyou_token, profile, domain_url } = data;
            let url = login_url || '';
            const getQueryByName = (url,name) => {
                var reg = new RegExp('[?]'+name+'=([^&#]+)');
                var query = url.match(reg);
                return query?query[1]:null;
            }
            let nccContext = {
                token: xiaoyou_token || '',
                tenantId: getQueryByName(url,'tenantId') || '',
                profile,
                coreDataCenter: domain_url
            }
            this.imUrl = im_url;
            // 动态加载im的js文件并创建登录的iframe
            this.appendSdk(im_url,url,nccContext);
            //拿到IM相关数据后发个通知
            PubSub.publish(pubSubActions.global.onLoadIMData, data);
        }
    }

    handleImCatch = () => {
        this.setState({
            loading: true
        })
        setTimeout(() => {
           this.setState({
               loading: false
           })
           document.getElementById('imBtnForNcc').click();
        }, 3000);
    }

    /**
     * im消息中心 
     */
    handleImXiaoxi(e) {
        try {
            if (!this.state.hasImInit) {
                this.handleImCatch();
                return;
            }
            this.setState({
                imVisible: true
            }, () => {
                this.getImWindow().postMessage({ imShow: true }, this.imUrl);
            });
            // const imDiv = document.getElementById("ykj-frame");
            // const selectMemberDiv = document.getElementsByClassName('fs-select-member-dialog')[0];
            // const getStyle = (obj,attr) => {
            //     return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle(obj)[attr]
            // }
            e.nativeEvent.stopImmediatePropagation();
            // let imShow = getStyle(imDiv,'display');
            // if(imShow === 'none') {
            //     this.ImTool.dispatch('imShow');
            // }
            // iframe点击处理
            // if(document.getElementById('mainiframe')){
            //     document.getElementById('mainiframe').contentDocument &&
            //         document.getElementById('mainiframe').contentDocument.addEventListener("mouseup",(e) => {
            //             // 人员icon点击时不隐藏
            //             if(e.target.className.indexOf('icon-renyuan') >= 0) {
            //                 return
            //             }
            //             // this.ImTool.dispatch('imHide');
            //             this.setState({ imVisible: false });
            //         })
            // }
            // if(this.state.hasBindEvent) {
            //     return;
            // }
            // 小友组件之外点击 隐藏小友功能
            // document.addEventListener("mouseup",(e) => {
            //     if(!imDiv.contains(e.target)){
            //         if(typeof selectMemberDiv !== 'undefined' && selectMemberDiv.contains(e.target)){
            //             return;
            //         }
            //         // this.ImTool.dispatch('imHide');
            //         this.setState({ imVisible: false });
            //     }
            // });
            // // 防止浏览器屏蔽弹窗增加事件处理
            // document.addEventListener('click',(e)=> {
            //     if(e.target === document.getElementsByClassName('sendmsg')[0]) {
            //         setTimeout(() => {
            //             if(this.state.hasSendOpenMsg) {
            //                 // window.openNew({name: "部门", appcode: "10100DEPT", is_cloud_app: false},true);
            //                 window.openNew(this.state.appOption,true,JSON.stringify(this.state.intelligentResponse));
            //                 this.setState({
            //                     hasSendOpenMsg: false
            //                 })
            //             }
            //         }, 500);
            //     }
            // })
            // document.addEventListener('keydown',(event)=>{
            //     var e = event || window.event || arguments.callee.caller.arguments[0];
            //     if(e && e.keyCode==13 ){
            //         setTimeout(() => {
            //             if(this.state.hasSendOpenMsg) {
            //                 // window.openNew({name: "部门", appcode: "10100DEPT", is_cloud_app: false},true);
            //                 window.openNew(this.state.appOption,true,JSON.stringify(this.state.intelligentResponse));
            //                 this.setState({
            //                     hasSendOpenMsg: false
            //                 })
            //             }
                        
            //         }, 500);
            //     }
            // });
            // this.setState({
            //     hasBindEvent: true
            // })
        } catch (error) {
            this.handleImCatch();
        }
    }
    // 每隔50分钟要重新请求login一次 防止im的session失效
    rerender() {
        if(this.reRenderHander){
            clearTimeout(this.reRenderHander);
        }
        this.reRenderHander = setTimeout(() => {
            this.login();
        },50 * 60 * 1000);
    }
    render() {
        const { imVisible } = this.state;
        let realEle = null;
        let xiaoxiElement = (
            <div className="iconContainer">
                <NCTooltip
                    placement='bottom'
                    overlay={langCheck("0000PUB-000600")} // 智能通讯
                    trigger='hover'
                    delayShow={500}
                    delay={1}
                    mouseLeaveDelay={0}
                >
                    <i
                        onClick={this.handleImXiaoxi}
                        className={"iconfont icon-xiaoxibip"}
                        id="imBtnForNcc"
                    />
                </NCTooltip>
                {/* 未读消息红点 如有需要放开即可 */}
                {/* {this.state.unreadTotalNum > 0 && <span className="im-unread-dot"/>} */}
            </div>
               
        )
        let loadingElement = (
            <div className="iconContainer">
                <div class="loader-inner ball-clip-rotate">
                    <div></div>
                </div>
            </div>
        )
        this.state.loading ? realEle = loadingElement : realEle = xiaoxiElement;
            return (
                <div className="item-wrap im">
                    {realEle}
                    <div>
                        <div id="messageContainer"></div>
                    </div>
                    <div
                        className='im-iframe-container'
                        ref={ref => this.imContainerRef = ref}
                        // 通过 visibility 控制显隐，display 会导致关闭之后再次打开闪一下，visibility 会好很多，不清除im内部啥原理
                        // style={{ display: imVisible ? 'block' : 'none' }}
                        style={{ visibility: imVisible ? 'visible' : 'hidden' }}
                    >
                        {/* <iframe src={IMSRC} /> */}
                    </div>
                </div>
            )
    }
}

// export default IM;
export default connect(
    (state) => ({
        needBind: state.appData.needBind
    })
)(IM);
